<template>
  <q-page padding>
    <PageHeader
      title="Criar Necessidade de Compra por planilha"
      :backRoute="{ name: 'compras-necessidades' }"
      backBehavior="route"
    />

    <div class="row col-12 q-mt-md q-gutter-sm">
      <div class="col-md">
        <div class="text-weight-bold text-brand-1">Unidade</div>
        <UnidadeSelect v-model="unidade" />
      </div>
      <div class="col-md">
        <div class="text-weight-bold text-brand-1">Urgência</div>
        <q-select
          :options="options"
          label="Selecione uma Urgencia"
          dense
          outlined
          v-model="urgencia"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
      <div class="col-md">
        <div class="text-weight-bold text-brand-1">Solicitante</div>
        <SelectSolicitante v-model="selected" />
      </div>
      <div class="col-md">
        <div class="text-weight-bold text-brand-1">Centro de Custo</div>
        <SelectCentroCustos v-model="centro" />
      </div>
    </div>

    <infot-upload
      :activeSlide="activeSlide"
      :infos="infos"
      :showUnidade="false"
      link="https://multpex-docs.s3.amazonaws.com/templates/necessidade-compra/modelo_planilha_subir_necessidade_compra_r4.xlsx"
    />

    <upload-planilha-layout
      titulo="Selecione o template com as informações desejadas"
      :file="file"
      :is-drag-over="isDragOver"
      :submit-disabled="
        !file || urgencia == '' || selected == '' || centro == ''
      "
      @drag-over="isDragOver = true"
      @drag-leave="isDragOver = false"
      @drop-file="onDrop($event)"
      @file-selected="onFileSelected"
      @instructions="activeSlide = !activeSlide"
      @submit="finalDialog = true"
    />

    <dialog-info-design
      class="row col-12"
      mensagem="Detalhes Necessidade Compra"
      subMensagem="Preencha os dados abaixo para complementar os dados para auxiliar no processo de compras."
      :showConteudo="true"
      :showCancelar="true"
      :exibir="finalDialog"
      :desabilitarConfirme="
        finalDialogForm.data_aplicacao == '' ||
        finalDialogForm.justificativa_contratacao == ''
      "
      @resultado="enviarTemplate"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          mask="##/##/####"
          v-model="finalDialogForm.data_aplicacao"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="finalDialogForm.data_aplicacao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Justificativa Contratação *
        </div>
        <q-input
          v-model="finalDialogForm.justificativa_contratacao"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
        <q-input
          v-model="finalDialogForm.detalhamento_tecnico"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Fornecedores
        </div>
        <q-input
          v-model="finalDialogForm.responsabilidades_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Contratante
        </div>
        <q-input
          v-model="finalDialogForm.responsabilidades_contratante"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
        <q-input
          v-model="finalDialogForm.possiveis_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
    </dialog-info-design>
  </q-page>
</template>

<script>
const columns = [{ name: "name", label: "Nome", field: "name", align: "left" }];

import { computed, onMounted, watch, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelectSolicitante from "../components/SelectSolicitante.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import InfotUpload from "../components/InfotUpload.vue";
import { useRouter } from "vue-router";
import UnidadeSelect from "../../../../components/unidade/UnidadeSelect.vue";
import SelectCentroCustos from "../components/SelectCentroCustos.vue";
import PageHeader from "../../../../components/PageHeader.vue";
import UploadPlanilhaLayout from "../../../../components/UploadPlanilhaLayout.vue";

export default {
  components: {
    SelectSolicitante,
    UnidadeSelect,
    SelectCentroCustos,
    DialogInfoDesign,
    InfotUpload,
    PageHeader,
    UploadPlanilhaLayout,
  },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const file = ref(null);
    const fileInput = ref(null);
    const isDragOver = ref(false);
    const router = useRouter();
    const finalDialog = ref(false);
    const activeSlide = ref(false);
    const finalDialogForm = ref({
      data_aplicacao: "",
      detalhamento_tecnico: "",
      responsabilidades_fornecedores: "",
      responsabilidades_contratante: "",
      possiveis_fornecedores: "",
      justificativa_contratacao: "",
    });

    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "A coluna código é OPCIONAL, caso o item já exista no seu catálogo, preencha essa informação, caso contrário, deixe em branco",
        icon: "delete",
      },
      {
        name: "Caso a coluna código seja preenchida e o item não exista no catálogo, o item NÃO SERÁ CRIADO, o código será ignorado.",
        icon: "view_column",
      },
      {
        name: "Caso a matricula do responsável não seja encontrada, ela também será ignorada.",
        icon: "do_not_disturb",
      },
      {
        name: "TODOS AS SELEÇÕES (unidade, urgência, solicitante e centro de custo) são OBRIGATÓRIAS!",
        icon: "event",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "event",
      },
    ]);

    const urgencia = ref("");
    const selected = ref([]);
    const rows = ref([]);
    const centro = ref("");
    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const filter = ref("");
    const unidade = ref("");

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (e) => {
      if (e.target.files[0]) file.value = e.target.files[0];
    };

    const onDrop = (e) => {
      isDragOver.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        file.value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviarTemplate = async (resultado) => {
      finalDialog.value = false;
      if (!resultado) return;

      if (!file.value || !file.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const planilha = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("compras/upload", {
          planilha,
          mapeamento: "necessidade_compra",
          adicional: {
            vendor_id: unidade.value?.id,
            solicitante_id: selected.value?.id,
            cost_center_id: centro.value?.id,
            tag_id: urgencia.value.value,
            data_aplicacao:
              finalDialogForm.value.data_aplicacao == ""
                ? undefined
                : finalDialogForm.value.data_aplicacao
                    ?.split("/")
                    ?.reverse()
                    ?.join("-"),
            detalhamento_tecnico:
              finalDialogForm.value.detalhamento_tecnico == ""
                ? undefined
                : finalDialogForm.value.detalhamento_tecnico,
            responsabilidades_fornecedores:
              finalDialogForm.value.responsabilidades_fornecedores == ""
                ? undefined
                : finalDialogForm.value.responsabilidades_fornecedores,
            responsabilidades_contratante:
              finalDialogForm.value.responsabilidades_contratante == ""
                ? undefined
                : finalDialogForm.value.responsabilidades_contratante,
            possiveis_fornecedores:
              finalDialogForm.value.possiveis_fornecedores == ""
                ? undefined
                : finalDialogForm.value.possiveis_fornecedores,
            justificativa_contratacao:
              finalDialogForm.value.justificativa_contratacao == ""
                ? undefined
                : finalDialogForm.value.justificativa_contratacao,
          },
        });

        $q.loading.hide();
        $q.notify({
          message: "Necessidade criada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        file.value = null;
        router.push({ name: "compras-necessidades" });
      } catch (error) {
        $q.loading.hide();
        console.log(error);
        $q.notify({
          message: "Erro ao criar necessidade",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const getSolicitantes = async (page = 1) => {
      try {
        const response = await store.dispatch("compras/getSolicitantes", {
          vendor_id: store.state.org.unidadeData.id,
          search: filter.value,
          page,
        });
        rows.value = response.data.results.data;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro ao procurar dados",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        getSolicitantes(pagination.value.page);
      }
    );
    watch(
      () => store.state.org.unidadeData,
      () => {
        getSolicitantes();
      }
    );
    watch(
      () => filter.value,
      () => {
        getSolicitantes();
      }
    );

    onMounted(getSolicitantes);

    return {
      enviarTemplate,
      file,
      fileInput,
      isDragOver,
      formatFileSize,
      onFileSelected,
      onDrop,
      options: [
        { label: "Normal", value: 1 },
        { label: "Urgente", value: 2 },
        { label: "Máquina Parada", value: 3 },
      ],
      urgencia,
      rows,
      columns,
      disable,
      pagination,
      filter,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getSolicitantes,
      selected,
      centro,
      activeSlide,
      unidade,
      infos,
      finalDialogForm,
      finalDialog,
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

a {
  text-decoration: none;
}
</style>
